import Container from "apps/website/components/layout/Container/Container";
import SectionLabelText from "apps/website/components/section/SectionLabelText/SectionLabelText";

import { data } from "./data";

export default function SectionCatsAreCarnivores() {
  return (
    <div className="px-5 bg-black pb-10 lg:pb-16">
      <Container>
        <div className="lg:mb-16">
          <SectionLabelText
            labelPrefix={data.labelText.labelPrefix}
            label={data.labelText.label}
            labelSuffix={data.labelText.labelSuffix}
            theme="dark"
            body={data.subtitle}
            title={data.title}
          />
        </div>

        <picture className="lg:max-w-[926px] mx-auto">
          <source
            media="(max-width:767px)"
            width={data.imageMobile.width}
            height={data.imageMobile.height}
            srcSet={data.imageMobile.src}
          />
          <img
            alt={data.imageDesktop.alt}
            src={data.imageDesktop.src}
            width={data.imageDesktop.width}
            height={data.imageDesktop.height}
            loading="lazy"
            className="mx-auto"
          />
        </picture>
      </Container>
    </div>
  );
}
